import { lazy } from 'react'

export const StudyInKoreaPage = lazy(() => import('./StudyInKorea'))
export const StudyInKoreaAddPage = lazy(() => import('./StudyInKoreaAdd'))
export const StudyInKoreaEditPage = lazy(() => import('./StudyInKoreaEdit'))